const isDevBuildEnv = () => (process.env.BUILD_ENV || '') === 'dev';

export default isDevBuildEnv;
